module.exports = __webpack_public_path__ + "img/img4.3dce87d3.jpg";